import React, { useEffect, useRef, useState } from 'react';
import classNames from 'classnames';
import { EmblaOptionsType } from 'embla-carousel';

import { JabraSlider, JabraSliderRef } from 'common/components/JabraSlider/JabraSlider';
import SliderCard from 'components/Product/Slider/SliderCard';

import { SliderProps } from './sliderTypes';

const Slider = ({
  header,
  cards,
  centerWhenNotScrollable,
  spotThemeClass,
}: SliderProps): React.ReactElement => {
  const [startIndex] = useState<number>(0);
  const sliderContainerRef = useRef<HTMLDivElement>(null);
  const jabraSlider = useRef<JabraSliderRef>(null);

  const sliderSettings: EmblaOptionsType = {
    containScroll: 'trimSnaps',
    loop: false,
    align: 'center',
  };

  const handleKeyDown = (event: KeyboardEvent) => {
    if (jabraSlider.current) {
      if (event.key === 'ArrowLeft') {
        jabraSlider.current.prev();
      } else if (event.key === 'ArrowRight') {
        jabraSlider.current.next();
      }
    }
  };

  useEffect(() => {
    const ref = sliderContainerRef.current;
    if (ref) {
      ref.addEventListener('keydown', handleKeyDown);
      return () => {
        ref.removeEventListener('keydown', handleKeyDown);
      };
    }
    return undefined;
  }, []);

  return (
    <>
      {!!cards.length && (
        <div className="w-full pb-12 pt-4 last:pb-0">
          <h2 className={classNames('heading-2', spotThemeClass)}>{header?.value}</h2>
          <div className="pt-4" ref={sliderContainerRef}>
            <JabraSlider
              mainClassName="relative w-full focus:outline-none"
              footerClassName="flex w-full justify-end pt-4"
              startIndex={startIndex}
              slideClassName="mr-2 md:mr-4"
              sliderSettings={sliderSettings}
              ref={jabraSlider}
              slideArrowsAlign="bottom"
              showSlideArrows={true}
              showSlideArrowsOnMobile={true}
              overflow={true}
              buttonVariant="primary"
              centerWhenNonScrollable={centerWhenNotScrollable?.value}
            >
              {cards.map((card) => (
                <SliderCard key={`sliderCard-${card.id}`} {...card} />
              ))}
            </JabraSlider>
          </div>
        </div>
      )}
    </>
  );
};

export { Slider };
